import React from "react";
import logo from "../assets/logo.png";

function FounderStory() {
  return (
    <div
      style={{
        fontFamily: "sans-serif",
        color: "#333",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
        padding: "40px 20px",
      }}
    >
      {/* Header */}
      <section
        style={{
          textAlign: "center",
          marginBottom: "50px",
        }}
      >
        <img
          src={logo}
          alt="Client Exchange Logo"
          style={{
            width: "120px",
            marginBottom: "20px",
          }}
        />
        <h1
          style={{
            fontSize: "2.8rem",
            color: "#2e7d32",
            fontWeight: "bold",
          }}
        >
          From the Ground Up – The Founder’s Story
        </h1>
        <p
          style={{
            fontSize: "1.1rem",
            maxWidth: "700px",
            margin: "20px auto 0",
            color: "#444",
          }}
        >
          A story about hard work, trust, and creating something that protects
          small business owners across Australia.
        </p>
      </section>

      {/* Story Section */}
      <section
        style={{
          backgroundColor: "white",
          maxWidth: "900px",
          margin: "0 auto",
          padding: "40px 30px",
          borderRadius: "20px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
          lineHeight: "1.9",
        }}
      >
        <p>
  I didn’t just start working in service businesses.I invested everything 
  I had into building a small operation from the ground up. 
  I wanted freedom. I wanted to build something
  of my own. I worked hard, early mornings and late afternoons, earning
  every single client through honesty, reliability, and trust.
</p>

<p>
  But as time went on, I noticed something that didn’t sit right with
  me. There was no real way to protect the value of what I’d built. If a
  contractor wanted to grow, sell, or step back, there was no safe
  system to hand over their clients without risk, doubt, or getting
  ripped off.
</p>

<p>
  That hit me hard because those clients weren’t just “names on a list.”
  They were people I’d shown up for week after week, in the rain and in
  the heat, building relationships based on trust.
</p>

<p>
  Before I ever picked up a mower, I worked in IT. I knew what good
  technology could do. So I decided to bring that world into ours. I
  built <strong>Client Exchange</strong>, a platform designed to protect
  what small business owners have spent years building. A place where
  buying, selling, or swapping clients isn’t risky. It’s verified,
  transparent, and fair.
</p>

<p>
  This isn’t just about business. It’s about dignity, honesty, and
  respect for the work we do. Because the trust we earn on the ground
  should never disappear when the job ends.
</p>
      </section>

      {/* Footer Link */}
      <div style={{ textAlign: "center", marginTop: "40px" }}>
        <a
          href="/"
          style={{
            color: "white",
            backgroundColor: "#2e7d32",
            padding: "10px 20px",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "bold",
          }}
        >
          ← Back to Home
        </a>
      </div>
    </div>
  );
}

export default FounderStory;

